import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { Option } from '../../../../../lib/OptionsLib';
import { CommonFilterHookReturn, HandleResetToDefaultValue } from '../commonHookReturn.types';
import useOptionsSelector from './useOptionsSelector';

interface UseMultiStaticOptionsSelectorProps {
  key: string;
  staticOptions: Option[];
  shouldIgnore?: boolean;
  /**
   * @description TODO: TEMOS QUE DESACOPLAR ESSE HOOK DOS SEARCH PARAMS, O HOOK JUNTO DO COMPONENTE TEM OUTROS USE CASES QUE NÃO SÃO FILTROS (CUSTOMRE-V2)
   */
  dontHandleSearchParams?: boolean;
  defaultValues?: string[] | string;
  shouldIgnoreDefaultFilters?: boolean;
}

interface UseMultiStaticOptionsSelectorOutput extends CommonFilterHookReturn {
  key: string;
  allOptions: Option[];
  selectedOptions: any[];
  setSelectedOptions: Dispatch<SetStateAction<any[]>>;
  hasSelectedOptions: boolean;
  handleUpdateInternalState: (expandableState: boolean) => void;
}

const useMultiStaticOptionsSelector = ({
  key,
  staticOptions,
  defaultValues,
  shouldIgnore,
  dontHandleSearchParams,
  shouldIgnoreDefaultFilters = true,
}: UseMultiStaticOptionsSelectorProps): UseMultiStaticOptionsSelectorOutput => {
  const hasNormalizedInitialValues = useRef(false);

  const {
    handleUpdateInternalState,
    hasSelectedOptions,
    selectedOptions,
    setSelectedOptions,
    cleanFilter,
    getSearchParamKeys,
    normalizeSelectedValues,
    formatDefaultValues,
    initialSelectedValuesFromSearchParams,
  } = useOptionsSelector({
    key,
    shouldIgnore,
    defaultValues,
    dontHandleSearchParams,
    shouldIgnoreDefaultFilters,
  });

  useEffect(() => {
    const hasAlreadyNormalized = hasNormalizedInitialValues.current;
    const hasInitialSelectedValues = initialSelectedValuesFromSearchParams.length > 0;

    if (hasAlreadyNormalized) {
      return;
    }

    if (hasInitialSelectedValues) {
      normalizeSelectedValues(staticOptions);
    }

    hasNormalizedInitialValues.current = true;
  }, []);

  const handleResetToDefaultValue: HandleResetToDefaultValue = () => {
    if (!defaultValues) {
      setSelectedOptions([]);
      return;
    }

    const formattedDefaultValues = formatDefaultValues(defaultValues);
    setSelectedOptions(formattedDefaultValues);
    normalizeSelectedValues(staticOptions);
  };

  return {
    key,
    allOptions: staticOptions,
    selectedOptions,
    setSelectedOptions,
    hasSelectedOptions,
    handleUpdateInternalState,
    cleanFilter,
    getSearchParamKeys,
    handleResetToDefaultValue,
  };
};

export default useMultiStaticOptionsSelector;
